// extracted by mini-css-extract-plugin
export default {"checkboxContainer":"styles_checkboxContainer__prCHZ","footerButtonContainer":"styles_footerButtonContainer__OKvDP","rightButtonGroup":"styles_rightButtonGroup__1wu1D"};